module.exports = __webpack_public_path__ + "static/media/ThursdaySpecial2x.cb96cf00.png";